import React, { Component } from "react";
import "./Chats.css";
import "../../src/Responsive.css";
import icon from "../Images/personicon.png";

const Chat = ({ message }) => {
  const { text, is_user_msg,icon } = message;
  return (
    // <span className={`Chat ${is_user_msg ? "is-user-msg" : ""}`}>{text}</span>
    <div className={`Chat ${is_user_msg ? "is-user-msg" : ""}`}>
      {!is_user_msg && icon && <img src={icon} alt="icon" className="chat-text-icon" />}
      <span>{text}</span>
      {is_user_msg }
      {/* {is_user_msg && icon && <img src={icon} alt="icon" className="chat-icon" />} */}
    </div>
  );
};

class Chats extends Component {
  constructor(props) {
    super(props);
    this.chatsRef = React.createRef();
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.chatsRef.current.scrollTop = this.chatsRef.current.scrollHeight;
  };

  render() {
    return (
      <div className="Chats" 
      ref={this.chatsRef}>
        {this.props.messages.map(message => (
          <Chat message={message} key={message.number} />
        ))}
      </div>
    );
  }
}

export default Chats;


// WEBPACK FOOTER //
// ./src/components/Chats.js